import React from "react";
import PropTypes from "prop-types";
import { FluentInput } from "../../../../../components/FluentUI/Fluent-Input";
import { Dropdown, Option } from "@fluentui/react-components";
import { durationValues } from "../template-utility";
import "./template-creation.scss";

const TemplateCreationFormRightTopNew = ({
  values,
  errors,
  handleChange,
  handleBlur,
  touched,
  setFieldValue,
}) => {
  const hasError = touched.Days && errors.Days;

  return (
    <div className="duration-row">
        <FluentInput
          id="Days"
          name="Days"
          label="Default Duration"
          placeholder="0 (unset)"
          value={values?.Days || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          type="number"
          min={0}
          required
          validationMessage={hasError ? errors.Days : undefined}
          componentStyle="duration-input"
          noKey
        />

        <div className={`duration-dropdown-wrapper ${ hasError ? "with-error-spacing" : "" }`}>
          <label className="duration-label">&nbsp;</label>
          <Dropdown
            aria-label="Duration Unit"
            style={{ width: "100%", minWidth: 0 }}   
            value={values?.DefaultDurationType?.name || ""}
            selectedOptions={[values?.DefaultDurationType?.name || ""]}
            onOptionSelect={(_, data) => {
              const selected = durationValues.find(
                (opt) => opt.name === data.optionValue
              );
              if (selected) {
                setFieldValue("DefaultDurationType", selected);
              }
            }}
          >
          {durationValues.map((opt) => (
            <Option key={opt.id} value={opt.name}>
              {opt.name}
            </Option>
          ))}
        </Dropdown>
      </div>
    </div>
  );
};

TemplateCreationFormRightTopNew.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: PropTypes.object,
  touched: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default TemplateCreationFormRightTopNew;